var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 2.125H14.1667C14.5579 2.125 14.875 2.44213 14.875 2.83333V14.1667C14.875 14.5579 14.5579 14.875 14.1667 14.875H2.83333C2.44213 14.875 2.125 14.5579 2.125 14.1667V2.83333C2.125 2.44213 2.44213 2.125 2.83333 2.125ZM3.54167 3.54167V13.4583H13.4583V3.54167H3.54167ZM4.95833 7.79167H12.0417V9.20833H4.95833V7.79167Z",
    fill: "#3B3B3B",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.ed4655b11af7b4849e05ffecb7f7953e.svg";
export { ForwardRef as ReactComponent };